export const formatSectionText = async (sectionLabel) => {
    // Guard against null or undefined input
    if (!sectionLabel) return ''

    const strippedSectionLabel = sectionLabel.trim()

    // Regex to match number prefix pattern (e.g. "6.1.2. ")
    const numberPattern = /(^(?:\d+\.?)+)\s(.*)$/

    // Try to match the pattern
    const match = strippedSectionLabel.match(numberPattern)

    // If no match found, return original string
    if (!match) {
        return strippedSectionLabel
    }

    // Extract the text portion (captured in second group)
    const text = match[2]

    // Capitalize each word
    const formatedText = capitalizeSentence(text)

    return formatedText
}

export const removeSectionNumberPrefix = (sectionLabel) => {
    const numberPattern = /(^(?:\d+\.?)+)\s(.*)$/
    const match = sectionLabel.match(numberPattern)
    if (!match) {
        return sectionLabel
    }
    return match[2]
}

export const formatSectionTextSync = (sectionLabel) => {
    if (!sectionLabel) return ''
    
    if (typeof sectionLabel !== 'string') { return '' }
    // Remove Whitespace
    const strippedSectionLabel = sectionLabel.trim()

    // Regex to match number prefix pattern (e.g. "6.1.2. ")
    const numberPattern = /(^(?:\d+\.?)+)\s(.*)$/

    // Try to match the pattern
    const match = strippedSectionLabel.match(numberPattern)

    // If no match found, return original string
    if (!match) {
        return strippedSectionLabel
    }

    // Extract the text portion (captured in second group)
    const text = match[2]

    // Capitalize each word
    const formatedText = capitalizeSentence(text)
    console.log('formatedText', formatedText)

    return formatedText
}

export const capitalizeWord = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}

export const capitalizeSentence = (sentence, delimiter = '_') => {
    // Words that should not be capitalized in titles (articles, conjunctions, prepositions)
    const lowercaseWordsRegex =
        /^(a|an|and|as|at|but|by|for|from|if|in|into|nor|of|on|or|over|so|the|to|via|with|yet)$/i
        
    const words = sentence.split(delimiter)

    return words
        .map((word, index) => {
            // Always capitalize first and last word
            if (index === 0 || index === words.length - 1) {
                return capitalizeWord(word)
            }

            // Check if word should be lowercase
            if (lowercaseWordsRegex.test(word)) {
                return word.toLowerCase()
            }

            // Otherwise capitalize normally
            return capitalizeWord(word)
        })
        .join(' ')
}

export const getSectionHierarchyLevel = (sectionTitle) => {
    if (!sectionTitle || typeof sectionTitle !== 'string') return 0
    
    // Match section numbering pattern with or without trailing period
    // Examples: "1", "1.", "1.1", "1.1.", "1.1.1", "1.1.1."
    const match = sectionTitle.match(/^(\d+(?:\.\d+)*)\.?\s/);
    
    if (!match) return 0
    
    // Count the number of segments to determine hierarchy level
    // "1" -> 1 segment -> level 0
    // "1.1" -> 2 segments -> level 1
    // "1.1.1" -> 3 segments -> level 2
    const numbering = match[1]
    const segments = numbering.split('.')
    const level = segments.length - 1
    
    return level
}

export const capitalizeFirstWord = (sectionName) => {
    const words = sectionName.split(' ')
    return words
        .map((word, index) => {
            if (index === 0) {
                return capitalizeWord(word)
            }
            return word
        })
        .join(' ')
}
